import {Injectable} from "@angular/core";
import {AlertController, ToastController} from "@ionic/angular";


@Injectable({
  providedIn: 'root'
})
export class AlertMessager {
    static showingAlert: boolean;

  constructor(
    private alert: AlertController,
    private toast: ToastController
    ) { }

    async showError(title: string, message: string) {
        const error = await this.alert.create({
          header: title,
          message: message,
          buttons: [
            {
              text: 'Dismiss',
              handler: () => {
                // Do nothing
              }
            }]
        });

        AlertMessager.showingAlert = true;
        await error.present();

        error.onDidDismiss().then(() => {
            AlertMessager.showingAlert = false;
        }
        );

    }

    async showConfirmation(title: string, message: string) {
        const error =  await this.alert.create({
            header: title,
            message: message,
            buttons: [
            {
                text: 'Ok',
                handler: () => {
                    // Do nothing
                }
            }]
        });
        error.present();

        AlertMessager.showingAlert = true;
        await error.present();

      error.onDidDismiss().then(() => {
          AlertMessager.showingAlert = false;
        }
      );
    }

  async prompt(title: string, message: string) {
    return new Promise(async (resolve) => {
      const prompt = await this.alert.create({
        header: title,
        message: message,
        buttons: [
          {
            text: 'Yes',
            handler: () => {
              resolve(true);
            }
          },
          {
            text: 'No',
            handler: () => {
              resolve(false);
            }
          }
        ]
      });
    
      await prompt.present();
    
      prompt.onDidDismiss().then(() => {
        resolve(false);
      });
    });
  }

  async showToast(header: string, message: string, color: string) {
    const toast = await this.toast.create({
      header,
      message,
      color,
      duration: 3000
    });
    await toast.present();
  }
}
